import { put, takeEvery } from 'redux-saga/effects';
import Actions from '../history-action';

export function* historyDepartmentService() {
	try {
		// Department API removed - HR module requires subscription check
		yield put(Actions.creators.getHistoryDepartmentSuccess([]));
	} catch (err) {
		yield put(Actions.creators.getHistoryDepartmentFail(err));
	}
}

export default function* historyWatcher() {
	yield takeEvery(Actions.types.GET_HISTORY_DEPARTMENT_START, historyDepartmentService);
}
